export default __webpack_public_path__ + "static/librixer-ccc9c87bc3830059f491c2856c8d5bdc.gif";